<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col md="6" sm="12">

          <b-form-group label-size='lg' label-class='adduserlabel' label='Full Name' label-for='fullName' :horizontal='false'>
            <b-form-input data-vv-name="user.fullName" v-validate="'required|max:255'" data-vv-as="Full Name" size="lg" id='fullName' v-model='user.fullName'></b-form-input>
            <span v-show="inputValidationErrors.has('user.fullName')" class="text-info">{{ inputValidationErrors.first('user.fullName') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='adduserlabel' label='Email Address' label-for='emailAddress' :horizontal='false'>
            <b-form-input
              id='emailAddress'
              size="lg"
              v-validate="'required|email|max:255'"
              data-vv-name="user.emailAddress"
              data-vv-as="Email Address"
              autocomplete="email"
              v-model='user.emailAddress'
            ></b-form-input>
            <span v-show="inputValidationErrors.has('user.emailAddress')" class="text-info">{{ inputValidationErrors.first('user.emailAddress') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='adduserlabel' label='Password' label-for='password' :horizontal='false'>
            <b-form-input
              id='password'
              type="password"
              v-validate="`${passwordRequired ? 'required|min:8|max:255' : 'max:255|min:8'}`"
              data-vv-name="user.password"
              data-vv-as="Password"
              autocomplete="new-password"
              size="lg"
              v-model='user.password'
            ></b-form-input>
            <span v-show="inputValidationErrors.has('user.password')" class="text-info">{{ inputValidationErrors.first('user.password') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='adduserlabel' label='CSE-IT Trained?' label-for='cse-it-trained' :horizontal='false'>
            <label class="switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle">
              <input
                id="positive_switch"
                @change="toggleIsCseitTrained"
                type="checkbox"
                class="switch-input"
                :checked="user.isCseitTrained"
              >
              <span class="switch-label" data-on="CSE-IT Trained" data-off="Not CSE-IT Trained"></span>
              <span class="switch-handle"></span>
            </label>
          </b-form-group>

          <b-form-group label-size='lg' label-class='adduserlabel' label='Active' label-for='active' :horizontal='false'>
            <b-form-select
             @change="handleSelect"
             data-vv-name="user.active"
             v-validate="'required'"
             data-vv-as="Active"
             size="lg"
             :value="user.isRemoved ? 'Deactivate' : user.active"
             :options="getUserActiveOptions(isSuperAdminOptions)"
             id='active'>
            </b-form-select>
             <span v-show="inputValidationErrors.has('user.active')" class="text-info">{{ inputValidationErrors.first('user.active') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='adduserlabel' label='Super Admin' label-for='isSuperAdmin' :horizontal='false'>
            <b-form-select
            data-vv-name="user.isSuperAdmin"
            v-validate="'required'"
            data-vv-as="is Super Admin"
             size="lg" :options="isSuperAdminOptions" id='isSuperAdmin' v-model='user.isSuperAdmin'>
            </b-form-select>
             <span v-show="inputValidationErrors.has('user.isSuperAdmin')" class="text-info">{{ inputValidationErrors.first('user.isSuperAdmin') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='adduserlabel' label='State' label-for='user-state'>
            <b-form-select
              data-vv-name="stateName"
              v-validate="'required'"
              data-vv-as="stateName"
              size="lg" :options="stateAndAbbrev" id='stateName' v-model='stateName'>
            </b-form-select>
            <span v-show="inputValidationErrors.has('stateName')" class="text-info">{{ inputValidationErrors.first('stateName') }}</span>
          </b-form-group>
          <b-form-group label-size='lg' label-class='adduserlabel' label='Primary Organization' label-for='primaryOrganization' :horizontal='false'>

            <b-form-select size="lg"
            data-vv-name="user.primaryOrganization"
            v-validate="'required'"
            data-vv-as="Primary Organization"
            :options="primaryOrganizationOptions(organizations)" id='primaryOrganization' v-model='user.primaryOrganization'>
            </b-form-select>
            <span v-show="inputValidationErrors.has('user.primaryOrganization')" class="text-info">{{ inputValidationErrors.first('user.primaryOrganization') }}</span>

          </b-form-group>


          <div v-if="addUser">
            <b-form-checkbox
              id="isOrgAdminOff"
              v-model="membership.isOrgAdmin"
              name="isOrgAdminOff"
              unchecked-value="false"
              switch
              incline
              class="m-3"
              >
              Organization Administrator: Would you like for this user to be able to share, unshare and transfer records?
            </b-form-checkbox>

            <b-form-checkbox
              id="isOrgManagerOff"
              v-model="membership.isManager"
              name="isOrgManagerOff"
              unchecked-value="false"
              switch
              incline
              class="m-3"
              >
              Organization Manager: Would you like this user to be able to view all of the records for your organization?
            </b-form-checkbox>
          </div>

          <b-button variant="success" @click="$emit('addOrUpdate', user)">Submit</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'create-user-form',
  props: {
    formUser: {
      type: Object,
      default: () => { return {} }
    },
    membership: {
      type: Object,
      default: () => {
        return {}
      }
    },
    addUser: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  computed: {
    ...mapGetters({
      stateAndAbbrev: 'getStateAndAbbrev',
      isSuperAdminOptions: 'getIsSuperAdminOptions',
      organizations: 'getAllOrganizations'
    }),

    passwordRequired () {
      return this.user.id === 0
    }
  },

  inject: ['$validator'],

  data: function () {
    return {
      tabIndex: 0,
      organizationId: -1,
      stateName: '',
      user: _.extend(cloneDeep(this.formUser), {
        password: this.formUser.hasPassword ? '************' : ''
      })
    }
  },
  created: function () {
    const primaryOrg = this.user.primaryOrganization
    if (primaryOrg) {
      this.stateName = primaryOrg.mailingStateAbbreviation
      this.user.primaryOrganization = primaryOrg.id
    } else {
      this.stateName = this.stateAndAbbrev[0].value
    }
    this.searchOrganizations()
  },
  methods: {
    primaryOrganizationOptions (organizations) {
      const organizationOptions = organizations.filter((org) => {
        if (!this.stateName) return true
        return org.mailingStateAbbreviation === this.stateName
      }).map((org) => {
        return { value: org.id, text: org.title }
      })
      organizationOptions.sort((a, b) => a.text > b.text ? 1 : -1)
      return organizationOptions
    },

    searchOrganizations () {
      this.$store.dispatch('getOrganizations', {})
    },

    getUserActiveOptions (options) {
      return [
        ...options,
        { value: 'Deactivate', text: 'Deactivate' }
      ]
    },

    handleSelect (value) {
      if (value === 'Deactivate') {
        this.user.isRemoved = true
      } else {
        this.user.isRemoved = false
        this.user.active = value
      }
    },

    toggleIsCseitTrained (val) {
      this.user.isCseitTrained = !this.user.isCseitTrained
      // auto select active as Yes
      if (this.user.isCseitTrained) {
        this.user.active = true
        this.user.isRemoved = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.switch.switch-text.switch-lg.wide-toggle {
  width: 180px;

  .switch-input:checked ~ .switch-handle {
    left: 154px; // 180px - 24px (pill size) - 2px (offset)
  }

  .switch-label {
    &::after,
    &::before {
      width: 156px; // 180px - 24px (pill size)
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/t1/Admin/UserForm.vue